import { render, staticRenderFns } from "./reference-get-sub-behavioural.vue?vue&type=template&id=23383a44&"
import script from "./reference-get-sub-behavioural.vue?vue&type=script&lang=js&"
export * from "./reference-get-sub-behavioural.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports